import { render, staticRenderFns } from "./fastaction.vue?vue&type=template&id=72b877a4"
import script from "./fastaction.ts?vue&type=script&lang=js&external"
export * from "./fastaction.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72b877a4')) {
      api.createRecord('72b877a4', component.options)
    } else {
      api.reload('72b877a4', component.options)
    }
    module.hot.accept("./fastaction.vue?vue&type=template&id=72b877a4", function () {
      api.rerender('72b877a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/home/fastaction/fastaction.vue"
export default component.exports